export const artigos = {
  f: { a: "a", A: "A", da: "da", na: "na" },
  m: { a: "o", A: "O", da: "do", na: "no" },
} as const;

export function listOf(items: readonly string[]): string {
  if (items.length <= 1) return items.join("");
  return `${items.slice(0, -1).join(", ")} e ${items.at(-1) ?? ""}`;
}

export function initialsOf(name: string): string {
  const words = name.trim().split(/\s+/).filter((word) => word.length > 0);
  return `${words[0]?.charAt(0) ?? ""}${words.length > 1 ? (words.at(-1)?.charAt(0) ?? "") : ""}`.toLocaleUpperCase("pt-BR");
}

export function folded(text: string): string {
  return text.normalize("NFD").replace(/\p{M}/gu, "").toLowerCase();
}

export function capitalized(text: string): string {
  return text.charAt(0).toLocaleUpperCase("pt-BR") + text.slice(1);
}

export const nbsp = "\u00a0";

export function wraps(text: string): string {
  return text.replaceAll(" · ", ` ·${nbsp}`).replace(/(\d[–-])(?=\d)/g, "$1\u2060");
}
